/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import type { Theme } from '@coursera/cds-core';
import { Typography2 } from '@coursera/cds-core';
import { InfoOutlineIcon } from '@coursera/cds-icons';

import { TooltipWrapper } from 'bundles/common/components/Tooltip';
import { DEFAULT_MAX_PREVIEW_FILE_SIZE_BYTES } from 'bundles/compound-assessments/lib/utils/renderPreviewUtils';

import _t from 'i18n!nls/compound-assessments';

const styles = {
  container: (theme: Theme) => css`
    display: flex;
    align-items: center;
    margin: ${theme.spacing(16, 0)};
  `,
  tooltip: () => css`
    display: flex;
  `,
  icon: (theme: Theme) => css`
    margin-right: ${theme.spacing(8)};
  `,
};

type Props = {
  fileAvailable: boolean;
  validFileSize: boolean;
};

export const RenderPreviewUnavailable: React.FC<Props> = ({ fileAvailable, validFileSize }) => {
  const tooltipMessage =
    fileAvailable && !validFileSize
      ? _t('File size limit for preview is #{fileSizeLimitMB}MB.', {
          fileSizeLimitMB: Math.floor(DEFAULT_MAX_PREVIEW_FILE_SIZE_BYTES / 1000000),
        })
      : _t('Failed to retrieve file.');

  return (
    <TooltipWrapper message={tooltipMessage} placement="bottom" css={styles.tooltip}>
      <div css={styles.container}>
        <InfoOutlineIcon size="small" css={styles.icon} color="support" />
        <Typography2 color="supportText" component="span">
          {_t('Preview unavailable')}
        </Typography2>
      </div>
    </TooltipWrapper>
  );
};

export default RenderPreviewUnavailable;
